import dayjs from 'dayjs';

export const getInitials = (name: string) => {
  const names = name.trim().split(' ');
  if (names.length === 0) return '';
  if (names.length === 1) return names[0].charAt(0).toUpperCase();
  return (names[0].charAt(0) + names[names.length - 1].charAt(0)).toUpperCase();
};

export const scrollToElement = (elementId: string) => {
  const element = document.getElementById(elementId);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}

export const formatDate = (dateString: string, format: string = 'MMMM D, YYYY') => {
  if (format === 'relative') {
    return dayjs(dateString).fromNow();
  }
  return dayjs.utc(dateString).format(format);
};

export const formatDateTz = (dateString: string, format: string = 'MMMM D, YYYY') => {
  const tz = dayjs.tz.guess();
  if (format === 'relative') {
    return dayjs.utc(dateString).tz(tz).fromNow();
  }
  return dayjs.utc(dateString).tz(tz).format(format);
};

export const getQueryParam = (key: string) => {
  const queryParams = new URLSearchParams(window.location.search);
  return queryParams.get(key);
};

export const getCurrentPage = () => {
  return parseInt(getQueryParam('page') || '1');
};

export const getSearch = () => {
  return getQueryParam('search') || undefined;
};
